export const MFA_MESSAGES = {
	HEADING: 'Two-factor authentication login code',
	SUB_HEADING:
		'Please enter the 6-digit login code from your authentication app.',
	ERROR: 'The login code you entered is not valid.',
	BACK_UP_HEADING: 'Backup code',
	BACK_UP_SUB_HEADING:
		'Enter one of the backup verification codes provided when you set up two factor authentication.',
};
